import React, {useEffect} from 'react'

import Swiper, { Mousewheel} from 'swiper';
import 'swiper/swiper-bundle.css'
import './NumberSwiper.css';


const NumberSwiper = ({sessionTime, handleSessionTime, handleCurrentTime, number, swiperContainer}) => {

const slides = [];

Swiper.use([Mousewheel]);


useEffect(() => {
	//set new class for each instance to allow for multiple slidechange instances
	const swiper = new Swiper(`.${swiperContainer}`, {
	slidesPerView: 5,
	spaceBetween: 0,
	centeredSlides: true,
	initialSlide: (sessionTime - 1) / 5,
	freeModeMomentumRatio: 3,
  
})
	swiper.on('slideChange', function() {
		handleSessionTime((swiper.activeIndex + 1) * 5)
		handleCurrentTime()

	})

}, [handleSessionTime, handleCurrentTime, sessionTime, number, swiperContainer])



for (let i=5 ; i < 100; i+=5) {
		slides.push(
			<li className='swiper-slide' key={i}>
				 {i}
			</li>
			)
	}

	return (
			<section className={`swiper-container ${swiperContainer}`} >
				<ul className='swiper-wrapper'>
					{slides}
				</ul>
			
				<div className='unactive-swiper-left'/>
				<div className='unactive-swiper-right'/>

			</section>
		)
}


export default NumberSwiper
